const LOCAL_STORAGE_KEY = 'lowCouponThreshold';
const DEFAULT_THRESHOLD = 1.9;

export default {
  namespaced: true,
  state: () => ({
    isLowCouponActive: false,
    lowCouponThreshold: localStorage.getItem(LOCAL_STORAGE_KEY)
      ? parseFloat(localStorage.getItem(LOCAL_STORAGE_KEY))
      : DEFAULT_THRESHOLD,
    bondType: {
      bondTypeId: '',
      bondTypeName: '',
      selectedGroupId: null,
      selectedGroupName: '',
      issuerIds: null,
      selectedRatings: [],
      filterMode: null,
    },
    bondGroups: [],
  }),
  mutations: {
    setLowCouponActive(state, value) {
      state.isLowCouponActive = value;
    },
    setLowCouponThreshold(state, value) {
      state.lowCouponThreshold = value;
      localStorage.setItem(LOCAL_STORAGE_KEY, value.toString());
    },
    SET_BOND_TYPE(state, payload) {
      state.bondType = { ...state.bondType, ...payload };
    },
    SET_BOND_GROUPS(state, groups) {
      state.bondGroups = groups;
    },
    RESET_BOND_TYPE(state) {
      state.bondType = {
        bondTypeId: '',
        bondTypeName: '',
        selectedGroupId: null,
        selectedGroupName: '',
        issuerIds: null,
        selectedRatings: [],
        filterMode: null,
      };
    },
  },
  actions: {
    setBondType({ commit }, payload) {
      commit('SET_BOND_TYPE', payload);
    },
    setBondGroups({ commit }, groups) {
      commit('SET_BOND_GROUPS', groups);
    },
    resetBondType({ commit }) {
      commit('RESET_BOND_TYPE');
    },
  },
  getters: {
    isLowCouponActive: state => state.isLowCouponActive,
    lowCouponThreshold: state => state.lowCouponThreshold,
    getBondType: state => state.bondType,
    getBondGroups: state => state.bondGroups,
  },
};
